export default "__VITE_ASSET__DwOlDwZ1__"